// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton_button__N0tkt","b2cMobile":"PrimaryButton_b2cMobile__lfahx"};